module.exports = __webpack_public_path__ + "static/mtb-p-3-e093daaf0adfa51f3741fe7729f6d0a2.png";